var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['flex flex-col min-h-screen bg-primary']},[_c('TrialBanner'),(_vm.$usesFeature('discount-banner'))?_c('DiscountBanner'):_vm._e(),_c('Header'),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }